/**
 * Centralized logging utility
 * In production, logs are suppressed unless explicitly enabled
 */

const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

interface Logger {
  log: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

const createLogger = (): Logger => {
  // In production, only log errors by default
  // Set VITE_ENABLE_LOGGING=true to enable all logs in production
  const enableLogging = isDevelopment || import.meta.env.VITE_ENABLE_LOGGING === 'true';

  return {
    log: (...args: unknown[]) => {
      if (enableLogging) {
        console.log(...args);
      }
    },
    error: (...args: unknown[]) => {
      // Always log errors, even in production
      console.error(...args);
      // In production, you might want to send errors to a logging service
      if (isProduction) {
        // Example: sendToErrorTrackingService(args);
      }
    },
    warn: (...args: unknown[]) => {
      if (enableLogging) {
        console.warn(...args);
      }
    },
    info: (...args: unknown[]) => {
      if (enableLogging) {
        console.info(...args);
      }
    },
    debug: (...args: unknown[]) => {
      if (enableLogging) {
        console.debug(...args);
      }
    },
  };
};

export const logger = createLogger();

